// ThemeProvider.jsx
import React from 'react'
import propTypes from "prop-types"

export const ThemeContext = React.createContext()

export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props)

    const savedTheme = localStorage.getItem('theme') || 'light'
    document.documentElement.setAttribute('data-theme', savedTheme)

    this.state = {
      theme: savedTheme,
      setTheme: this.setTheme,
    }
  }

  setTheme = (newTheme) => {
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
    this.setState({ theme: newTheme })
  }

  render() {
    return (
        <ThemeContext.Provider value={{ theme: this.state.theme, setTheme: this.setTheme }}>
          {this.props.children}
        </ThemeContext.Provider>
    )
  }
}

ThemeProvider.propTypes = {
  children: propTypes.any,
}
